<template>
    <div>
        <transition name="fade">
            <div
                    v-if="showAlert"
                    style="z-index: 9999"
                    class="fixed bottom-0 left-0 flex flex-col w-full text-white md:top-0 md:mt-10 md:bottom-auto">

                <div class="w-full p-5 md:w-1/2 md:mx-auto md:rounded md:my-1 flex"
                    :class="{'bg-red-600': type === 'error', 'bg-green-600': type === 'success', 'bg-blue-600': type === 'info'}">
                    <div class="alert-text w-11/12">
                        <div v-for="(message, k) in messages" :key="k">
                            {{ message }}
                        </div>
                    </div>

                    <div class="w-1/12 text-right alert-close">
                        <a @click="close()" class="cursor-pointer">x</a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'alert',

        data() {
            return {
                showAlert: false,
                type: 'error',
                messages: []
            }
        },

        watch: {
            showAlert() {
                if(this.showAlert) {
                    setTimeout(() => {
                        this.showAlert = false;
                    }, 4000);
                }
            }
        },

        methods: {
            show(message) {
                this.reset();

                this.showAlert = true;
                this.messages.push(message);
            },

            info(message) {
                this.reset();

                this.type = 'info';
                this.showAlert = true;
                this.messages.push(message);
            },

            close() {
                this.showAlert = false;
                this.messages = [];
            },

            reset() {
                this.type = 'error';
                this.messages = [];
            },

            success(message) {
                this.reset();

                this.type = 'success';
                this.showAlert = true;
                this.messages.push(message);
            },

            showValidationErrors(data) {
                this.reset();

                if(data.errors) {
                    for(let e in data.errors) {
                        for(let m in data.errors[e]) {
                            this.messages.push(data.errors[e][m]);
                        }
                    }

                    this.showAlert = true;
                } else if (data.message) {
                    return this.show(data.message);
                }
            },

            showResponseErrors(err) {
                this.reset();

                if(err.data?.data?.message || err.data?.message) {
                    this.showValidationErrors(
                        err.data?.data || err.data
                    )
                } else {
                    this.show(
                        this.$t('unknown_error_try_again')
                    )
                }

                return err;
            }
        }
    }
</script>